var _style, _path, _path2, _path3, _path4, _path5, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultBotImage = function SvgDefaultBotImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 215.9 215.9"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#fff}.st106{fill:#c9e0ea}.st107{fill:none;stroke:#c9e0ea;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 108,
    r: 108,
    style: {
      fill: "#0073a8"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.9 34h4.7v19.4h-4.7z",
    className: "st106"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 108.3,
    cy: 31,
    r: 7.6,
    style: {
      fill: "#f4f8fa"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.2 122h14M22.7 122h14",
    className: "st107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.4 180.1H78.1c-15.6 0-28.3-12.7-28.3-28.3v-43.2c0-32.3 26.2-58.4 58.4-58.4 32.3 0 58.4 26.2 58.4 58.4v43.2c.1 15.6-12.6 28.3-28.2 28.3",
    className: "st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3 141.7c0 6.1 5 11.4 11.2 11.2 6-.1 10.8-5 10.8-11v-.3c0-.9-.7-1.6-1.6-1.6H98.9c-.9 0-1.6.8-1.6 1.7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.6 151.2c1.7 1.1 3.7 1.7 5.9 1.7 2 0 3.9-.6 5.5-1.6-1.4-1.7-3.4-2.7-5.7-2.7s-4.3 1-5.7 2.6",
    style: {
      fill: "#f3911d"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.5 136.1h-1.8v-28.4h1.8c6.9 0 12.4 5.6 12.4 12.4v3.6c0 6.9-5.6 12.4-12.4 12.4M48.1 136.1h1.8v-28.4h-1.8c-6.9 0-12.4 5.6-12.4 12.4v3.6c0 6.9 5.5 12.4 12.4 12.4",
    className: "st106"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 108.3,
    cy: 96.8,
    r: 24.3,
    style: {
      fill: "#0073ac"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.3,
    cy: 96.4,
    r: 11.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 88.4,
    r: 4.4,
    className: "st2"
  })));
};
export default SvgDefaultBotImage;